import { BonusResult } from "slotworks/model/gameplay/records/results/bonus-result";

export type PickBonusVariant = "single_tier" | "three_tier";

export type EggColor = "white" | "silver" | "gold" | "diamond" | "fox";

export interface EggPickSchema {
    color: EggColor;
    value: number;
}

export class FowlPickBonusResult extends BonusResult {
    public resultType = "FowlPickBonusResult";

    public bonusVariant: PickBonusVariant;

    public hits: EggPickSchema[] = [];
    public misses: EggPickSchema[] = [];
    public chickenPositions: number[] = [];

    public jackpotEgg?: EggPickSchema;
}
